import React from 'react';
import styled from 'styled-components';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { history } from 'store/configureStore';
import PropTypes from 'prop-types';
import { isAccountPage, isProgramFilePage } from 'helpers';

/**
 * サイドバーリンクコンポーネント
 */
const SidebarLink = (props) => {
  const getClasss = () => {
    let style = 'list-group-item list-group-item-action';
    if (history.location.pathname.match(props.to)) {
      style += ' active';
    } else {
      for (const key in props.exclude) {
        const page = new RegExp(props.exclude[key].replace(/:[0-9a-zA-Z_-]*/g, '[^/]*'));
        const reg = new RegExp(page);
        if (history.location.pathname.match(reg)) {
          style += ' active';
          break;
        }
      }
    }
    return style;
  };
  return (
    <Link to={props.to} className={getClasss()}>{props.title}</Link>
  );
};

SidebarLink.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  exclude: PropTypes.array,
};

SidebarLink.defaultProps = {
  exclude: []
};

const AauthedSidebar = () => {
  // 管理者アカウントページ
  if (isAccountPage()) {
    return (
      <StyledSidebar className='col-2 pt-3'>
        <SidebarLink
          to='/adm/accounts'
          title='Admin list'
          exclude={[
            '/adm/account/regist',
            '/adm/account/edit/:id',
            '/adm/account/detail/:id',
          ]}
        />
      </StyledSidebar>
    );
  // プログラムファイル系のページ
  } else if (isProgramFilePage()) {
    return (
      <StyledSidebar className='col-2 pt-3'>
        <SidebarLink 
          to='/srv/files'
          title='Program File List'
          exclude={[
            '/srv/version/edit/:id',
            '/srv/version/detail/:id',
          ]}
        />
        <SidebarLink to='/srv/settings'
          title='Custom Prog List'
          exclude={[
            '/srv/setting/regist',
            '/srv/setting/edit/:id',
            '/srv/setting/detail/:id',
          ]}
        />
      </StyledSidebar>
    );
  } else {
    return '';
  }
};

const StyledSidebar = styled(ListGroup)`
  background-color: #F5F7F7;
  min-height: calc(100vh - 90px);
`;

export default AauthedSidebar;
